import React, { useState } from 'react';
import { Button, Typography, Card, CardContent, Grid, Container, Box, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Dialogue } from './section-components/Dialogue';
import FreeValuationForm from './BookEvaluation';
import bannerVideo from '../assets/img/Home/home screen video.mp4';
import '../assets/css/NewsUpdates.css';

const NewsUpdates = () => {
  const [openEvaluation, setOpenEvaluation] = useState(false);
  const [openContact, setOpenContact] = useState(false);
  const navigate = useNavigate();

  const services = [
    {
      title: "Buy Property",
      description: "Expert local guidance to find your dream home",
      icon: "🏠"
    },
    {
      title: "Sell Property", 
      description: "Fast selling with accurate pricing and targeted marketing",
      icon: "💰"
    },
    {
      title: "Rent Property",
      description: "Professional tenant screening and legal paperwork",
      icon: "🔑"
    },
    {
      title: "Property Management",
      description: "Full-service support for stress-free management",
      icon: "⚙️"
    }
  ];

  const homeServices = [
    {
      title: "Interior Design",
      description: "Modular kitchen setups and interior styling",
      icon: "🎨"
    },
    {
      title: "Heating & Plumbing",
      description: "Professional heating and plumbing services",
      icon: "🔥"
    },
    {
      title: "Electrical Work",
      description: "Electrical installations and repairs",
      icon: "⚡"
    },
    {
      title: "General Maintenance",
      description: "Windows, doors, painting, and ceiling work",
      icon: "🔧"
    }
  ];

  const legalServices = [
    {
      title: "Will Drafting",
      description: "Estate planning and will preparation",
      icon: "📜"
    },
    {
      title: "Property Law",
      description: "Documentation and legal consulting",
      icon: "⚖️"
    },
    {
      title: "Mortgage Advice",
      description: "Application support and guidance",
      icon: "🏦"
    },
    {
      title: "Insurance",
      description: "Home & life insurance guidance",
      icon: "🛡️"
    }
  ];

  return (
    <div className="news-updates-page">
      {/* Hero Section with Video Background */}
      <div className="news-hero-area">
        <video
          autoPlay
          muted
          loop
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: -1,
          }}
        >
          <source src={bannerVideo} type="video/mp4" />
        </video>



        <Container>
          <div className="text-center">
            <Typography
              variant="h2"
              sx={{
                fontFamily: 'Ibarra Real Nova',
                fontWeight: 800,
                color: 'white',
                textShadow: '0 4px 8px rgba(0,0,0,0.2)',
                fontSize: '3rem',
                marginBottom: '20px',
                letterSpacing: '2px',
                '@media (maxWidth: 600px)': {
                  fontSize: '2rem',
                },
                '@media (maxWidth: 400px)': {
                  fontSize: '1.6rem',
                },
              }}
            >
              Royale Spaces Estate Agents
            </Typography>
            {/* <Typography
              variant="h5"
              sx={{
                fontSize: '1.5rem',
                color: 'white',
                fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                fontStyle: 'italic',
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.8)',
                marginBottom: '30px',
              }}
            >
              Rugby, Coventry & West Midlands
            </Typography> */}
            <Button
              sx={{
                padding: '12px 24px',
                color: '#fff',
                backgroundColor: '#d8b035',
                fontSize: { xs: '1rem', sm: '1.2rem' },
                fontWeight: '600',
                width: { xs: '100%', sm: 'auto' },
                '&:hover': {
                  backgroundColor: '#c5a02f',
                  transform: 'scale(1.05)',
                  transition: 'all 0.3s ease',
                },
              }}
              size="large"
              onClick={() => setOpenEvaluation(true)}
            >
              Get Free Valuation
            </Button>
          </div>
        </Container>
      </div>

      {/* Quick Links Section */}
      <section className="quick-links-section odd-section">
        <Container>
          <div className="quick-links-header">
            <div className="section-title">
              <Typography variant="h6">Quick Access</Typography>
              <Typography variant="h2">Quick Links</Typography>
              <Typography variant="body1">
                Fast access to our most popular services
              </Typography>
            </div>
          </div>

          <Grid container spacing={4} className="quick-links-grid">
            <Grid item xs={12} sm={6} md={3}>
              <div className="quick-link-card">
                <div className="quick-link-icon">
                  🏠
                </div>
                <Typography variant="h6" className="quick-link-title">
                  Buy Property
                </Typography>
                <Typography variant="body2" className="quick-link-description">
                  Find your dream home with expert guidance and local market knowledge
                </Typography>
                <Button 
                  className="quick-link-button" 
                  size="small"
                  onClick={() => navigate('/sales/India')}
                >
                  Start Search
                </Button>
                <div className="quick-link-stats">
                  <div className="quick-link-stat">
                    <span className="quick-link-stat-number">500+</span>
                    <span className="quick-link-stat-label">Properties</span>
                  </div>
                  <div className="quick-link-stat">
                    <span className="quick-link-stat-number">24h</span>
                    <span className="quick-link-stat-label">Response</span>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <div className="quick-link-card">
                <div className="quick-link-icon">
                  💰
                </div>
                <Typography variant="h6" className="quick-link-title">
                  Sell Property
                </Typography>
                <Typography variant="body2" className="quick-link-description">
                  Get the best price for your property with our proven marketing strategies
                </Typography>
                <Button 
                  className="quick-link-button" 
                  size="small"
                  onClick={() => navigate('/sales/India')}
                >
                  Free Valuation
                </Button>
                <div className="quick-link-stats">
                  <div className="quick-link-stat">
                    <span className="quick-link-stat-number">95%</span>
                    <span className="quick-link-stat-label">Success Rate</span>
                  </div>
                  <div className="quick-link-stat">
                    <span className="quick-link-stat-number">30d</span>
                    <span className="quick-link-stat-label">Avg Sale</span>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <div className="quick-link-card">
                <div className="quick-link-icon">
                  🔑
                </div>
                <Typography variant="h6" className="quick-link-title">
                  Rent Property
                </Typography>
                <Typography variant="body2" className="quick-link-description">
                  Professional tenant screening and comprehensive rental management
                </Typography>
                <Button 
                  className="quick-link-button" 
                  size="small"
                  onClick={() => navigate('/sales/India')}
                >
                  View Rentals
                </Button>
                <div className="quick-link-stats">
                  <div className="quick-link-stat">
                    <span className="quick-link-stat-number">200+</span>
                    <span className="quick-link-stat-label">Rentals</span>
                  </div>
                  <div className="quick-link-stat">
                    <span className="quick-link-stat-number">99%</span>
                    <span className="quick-link-stat-label">Occupancy</span>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <div className="quick-link-card">
                <div className="quick-link-icon">
                  ⚙️
                </div>
                <Typography variant="h6" className="quick-link-title">
                  Property Management
                </Typography>
                <Typography variant="body2" className="quick-link-description">
                  Full-service property management with rent protection and 24/7 support
                </Typography>
                <Button 
                  className="quick-link-button" 
                  size="small"
                  onClick={() => navigate('/property-management')}
                >
                  Learn More
                </Button>
                <div className="quick-link-stats">
                  <div className="quick-link-stat">
                    <span className="quick-link-stat-number">150+</span>
                    <span className="quick-link-stat-label">Managed</span>
                  </div>
                  <div className="quick-link-stat">
                    <span className="quick-link-stat-number">24/7</span>
                    <span className="quick-link-stat-label">Support</span>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Property Services Section */}
      <section className="services-section even-section">
        <Container>
          <div className="section-header">
            <div className="section-title">
              <Typography variant="h6">Our Services</Typography>
              <Typography variant="h2">Residential & Commercial Property Services</Typography>
              <Typography variant="body1">
                Complete Property Services – Buy, Sell, Rent, Manage
              </Typography>
            </div>
          </div>

          <Typography variant="body1" className="intro-text">
            Looking for the Best Real Estate Agency in India? At Royale Spaces, we offer comprehensive end-to-end support for both residential and commercial clients across major Indian cities. Our expertise in the Indian property market ensures you get the best value for your investment.
          </Typography>

          <Grid container spacing={4} className="services-grid">
            {services.map((service, index) => {
              // Determine navigation path based on service title
              let path = '';
              if (service.title === 'Buy Property') path = '/sales/India';
              else if (service.title === 'Sell Property') path = '/sales/India';
              else if (service.title === 'Rent Property') path = '/sales/India';
              else if (service.title === 'Property Management') path = '/property-management';
              return (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card
                    className="service-card"
                    style={{ cursor: 'pointer' }}
                    onClick={() => path && navigate(path)}
                  >
                    <CardContent className="service-card-content">
                      <div className="service-icon">
                        <span style={{ fontSize: '2rem' }}>{service.icon}</span>
                      </div>
                      <Typography variant="h6" className="service-title">
                        {service.title}
                      </Typography>
                      <Typography variant="body2" className="service-description">
                        {service.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>

          <Typography variant="body1" className="conclusion-text">
            We make every transaction smooth, secure, and successful. As one of the most trusted real estate agencies in India, our approach combines deep local market knowledge with transparent and professional service standards.
          </Typography>
        </Container>
      </section>

      {/* Home Services Section */}
      <section className="home-services-section odd-section">
        <Container>
          <div className="section-header">
            <div className="section-title">
              <Typography variant="h6">Home Services</Typography>
              <Typography variant="h2">Home Services & Repairs</Typography>
              <Typography variant="body1">
                Complete Interior and Maintenance Support
              </Typography>
            </div>
          </div>

          <Typography variant="body1" className="intro-text">
            Royale Spaces goes beyond traditional real estate services. Our dedicated Home Services Team makes moving in, renovating, or upgrading your property seamless across India.
          </Typography>

          <Typography variant="body1" className="main-text">
            Beyond buying and selling, Royale Spaces also supports your lifestyle with trusted home services. Whether you're moving in or renovating, we offer:
          </Typography>

          <Grid container spacing={4} className="services-grid">
            {homeServices.map((service, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                              <Card className="home-service-card">
                <CardContent className="service-card-content">
                  <div className="service-icon">
                    <span style={{ fontSize: '2rem' }}>{service.icon}</span>
                  </div>
                    <Typography variant="h6" className="service-title">
                      {service.title}
                    </Typography>
                    <Typography variant="body2" className="service-description">
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Typography variant="body1" className="conclusion-text">
            Our experienced team delivers high-quality results across every detail — keeping your property safe, stylish, and functional.
          </Typography>
        </Container>
      </section>

      {/* Legal & Financial Services Section */}
      <section className="legal-services-section even-section">
        <Container>
          <div className="section-header">
            <div className="section-title">
              <Typography variant="h6">Legal Services</Typography>
              <Typography variant="h2">Legal & Financial Support Services</Typography>
              <Typography variant="body1">
                Legal, Wills & Mortgage Services – Expert Advice You Can Trust
              </Typography>
            </div>
          </div>

          <Typography variant="body1" className="intro-text">
            As part of our commitment to complete support, we also assist with legal and financial services. From drafting wills to navigating property law and finding the best mortgage solutions — we've got you covered.
          </Typography>

          <Typography variant="body1" className="main-text">
            We know property deals go hand-in-hand with legal and financial matters. That's why we offer complete support every step of the way.
          </Typography>

          <Typography variant="body1" className="highlight-text">
            Looking for guidance from Top UK Estate Agencies 2025 who understand every step of the journey? Royale Spaces connects you with:
          </Typography>

          <Grid container spacing={4} className="services-grid">
            {legalServices.map((service, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                              <Card className="legal-service-card">
                <CardContent className="service-card-content">
                  <div className="service-icon">
                    <span style={{ fontSize: '2rem' }}>{service.icon}</span>
                  </div>
                    <Typography variant="h6" className="service-title">
                      {service.title}
                    </Typography>
                    <Typography variant="body2" className="service-description">
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Typography variant="body1" className="conclusion-text">
            No need to go elsewhere — we make your journey smoother by keeping it all under one trusted roof.
          </Typography>
        </Container>
      </section>

      {/* Lettings & Property Management Services Section */}
      <section className="lettings-services-section odd-section">
        <Container>
          <div className="section-header">
            <div className="section-title">
              <Typography variant="h6">Property Management</Typography>
              <Typography variant="h2">Lettings & Property Management Services</Typography>
              <Typography variant="body1">
                Expert Support for Landlords in the West Midlands
              </Typography>
            </div>
          </div>

          <Typography variant="body1" className="intro-text">
            Whether you're a first-time landlord or managing a growing portfolio, we offer tailored letting services trusted across the UK:
          </Typography>

          <Grid container spacing={4} className="services-grid">
            <Grid item xs={12} md={4}>
              <Card className="letting-service-card">
                <CardContent className="service-card-content">
                  <div className="service-icon">
                    <span style={{ fontSize: '2rem' }}>🏠</span>
                  </div>
                  <Typography variant="h6" className="service-title">
                    1. Full Property Management with Rent Protection
                  </Typography>
                  <Typography variant="body2" className="service-description">
                    Our Full Property Management Service is ideal for landlords who want peace of mind. We handle everything — from tenant finding, rent collection, to property maintenance — and even offer rent protection to keep your income safe.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card className="letting-service-card">
                <CardContent className="service-card-content">
                  <div className="service-icon">
                    <span style={{ fontSize: '2rem' }}>💰</span>
                  </div>
                  <Typography variant="h6" className="service-title">
                    2. Rent Collection Service
                  </Typography>
                  <Typography variant="body2" className="service-description">
                    Need help collecting rent, but still want to manage your property independently? Our Rent Collection Service ensures reliable monthly payments, while you handle property visits, upkeep, and other personal decisions.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card className="letting-service-card">
                <CardContent className="service-card-content">
                  <div className="service-icon">
                    <span style={{ fontSize: '2rem' }}>🔍</span>
                  </div>
                  <Typography variant="h6" className="service-title">
                    3. Tenant Find Service
                  </Typography>
                  <Typography variant="body2" className="service-description">
                    We also offer a professional Tenant Find Service — designed to match your property with reliable tenants. We manage everything from advertising & viewings, tenant referencing & agreements, to inventory reports & condition statements.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Typography variant="body1" className="conclusion-text">
            It's all handled by one of the Best Letting Agents in the UK, so you can rent with confidence.
          </Typography>
        </Container>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section even-section">
        <Container>
          <div className="section-header">
            <div className="section-title">
              <Typography variant="h6">Why Choose Us</Typography>
              <Typography variant="h2">Why Choose Royale Spaces?</Typography>
              <Typography variant="body1">
                Building Trust, Value, and Complete Peace of Mind
              </Typography>
            </div>
          </div>

          <Typography variant="body1" className="intro-text">
            At Royale Spaces, we don't just deal with property — we build trust, value, and complete peace of mind. Here's why landlords, homeowners, and families across the West Midlands choose us as their preferred estate agency in the UK:
          </Typography>

          <Grid container spacing={4} className="reasons-grid">
            <Grid item xs={12} md={6}>
              <div className="reason-item">
                <div className="reason-number">1</div>
                <div className="reason-content">
                  <Typography variant="h6" className="reason-title">
                    Top-Rated Estate Agency in West Midlands
                  </Typography>
                  <Typography variant="body2" className="reason-description">
                    Recognised among the Top UK Estate Agencies 2025, we're proud to be one of the most trusted and best-reviewed estate agents across Coventry, Rugby, and Birmingham.
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="reason-item">
                <div className="reason-number">2</div>
                <div className="reason-content">
                  <Typography variant="h6" className="reason-title">
                    All-in-One Property Solutions
                  </Typography>
                  <Typography variant="body2" className="reason-description">
                    From helping you buy, sell, rent, or manage property, to offering home services like interiors, plumbing, and electrical work — we deliver everything under one reliable roof.
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="reason-item">
                <div className="reason-number">3</div>
                <div className="reason-content">
                  <Typography variant="h6" className="reason-title">
                    Full Property Management with Rent Protection
                  </Typography>
                  <Typography variant="body2" className="reason-description">
                    Our rent protection service gives landlords complete peace of mind — with guaranteed rent collection, tenant handling, and 24/7 maintenance support.
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="reason-item">
                <div className="reason-number">4</div>
                <div className="reason-content">
                  <Typography variant="h6" className="reason-title">
                    Legal, Will, Insurance & Mortgage Support
                  </Typography>
                  <Typography variant="body2" className="reason-description">
                    We provide expert help in drafting wills, navigating property law, securing mortgages, and finding the right insurance — making us a truly full-service estate agency.
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="reason-item">
                <div className="reason-number">5</div>
                <div className="reason-content">
                  <Typography variant="h6" className="reason-title">
                    Experienced, Local & Personalised Approach
                  </Typography>
                  <Typography variant="body2" className="reason-description">
                    Our team understands the local market deeply and offers personalised guidance tailored to your property goals — with honesty, clarity, and no hidden surprises.
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="reason-item">
                <div className="reason-number">6</div>
                <div className="reason-content">
                  <Typography variant="h6" className="reason-title">
                    Fast, Transparent & Hassle-Free Process
                  </Typography>
                  <Typography variant="body2" className="reason-description">
                    We value your time. That's why we deliver quick property solutions, clear documentation, and a smooth experience — every single time.
                  </Typography>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>



      {/* Call to Action Section */}
      <section className="cta-section">
        <Container>
          <div className="cta-content">
            <Typography variant="h3" className="cta-title">
              Let's Work Together
            </Typography>
            <Typography variant="body1" className="cta-description">
              Whether you need help selling your home, managing a rental, upgrading interiors, or planning your future — Royale Spaces is here for you.
            </Typography>
            <Typography variant="body1" className="cta-subtitle">
              Contact us today to schedule a free consultation or book an instant property valuation.
            </Typography>
            <div className="cta-buttons">
              <Button
                className="cta-button primary"
                size="large"
                onClick={() => setOpenContact(true)}
              >
                Contact Us
              </Button>
            </div>
          </div>
        </Container>
      </section>

      {openEvaluation && (
        <Dialogue open={openEvaluation} onClose={() => setOpenEvaluation(false)}>
          <FreeValuationForm onClose={setOpenEvaluation} isContactForm={false}/>
        </Dialogue>
      )}

      {openContact && (
        <Dialogue open={openContact} onClose={() => setOpenContact(false)}>
          <FreeValuationForm onClose={setOpenContact} isContactForm={true}/>
        </Dialogue>
      )}
    </div>
  );
};

export default NewsUpdates; 